export default {
      id: "member-outline-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#member-outline",
      toString: function () {
        return this.url;
      }
    }